import { render, staticRenderFns } from "./WFDistributeConfigEdit.vue?vue&type=template&id=3b58e196&scoped=true"
import script from "./WFDistributeConfigEdit.vue?vue&type=script&lang=js"
export * from "./WFDistributeConfigEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b58e196",
  null
  
)

export default component.exports